module.exports = __webpack_public_path__ + "img/9.741c7593.jpg";